//搜索框
function searchFn(){
    if($(window).width()>1180){
        if($('#q').attr('class').indexOf('active')<0){
            $('#q').addClass('active');
            return false;
        }else{
            if($('#q').val()==''){
                $('#q').removeClass('active');
                return false;
            }
        }
    }else{

    }
};
$('#searchcontainer').click(function(e){e.stopPropagation();});
$(document).click(function(){$('#q').removeClass('active');});
function resizeHeader(){
    if($(window).width()>1180){
        $('.header_bg').hide();
        $('.header div ul:nth-child(2) li').unbind('click');
        $('.header div ul:nth-child(2)').addClass('header_nav');
        $('.header div ul:nth-child(2) li').removeClass('active');
        $('.header .toggle').removeClass('active');
        $('.header div>div').removeClass('active');
    }else{
        $('.header div ul:nth-child(2)').removeClass('header_nav');
        $('.header div ul:nth-child(2) li').unbind('click');
        $('.header div ul:nth-child(2) li').click(function(){
            $(this).toggleClass('active').siblings().removeClass('active');
        });
    }
};
resizeHeader();
$(window).resize(function(){
    resizeHeader();
});
$('.header .toggle').click(function(){
    $(this).toggleClass('active');
    $('.header_bg').toggle();
    $('.header div>div').toggleClass('active');
});
$(".header_bg").click(function(){
    $(this).hide();
    $('.header div>div').removeClass('active');
    $('.header .toggle').removeClass('active');
});